import { Fetcher } from '../../Fetcher';

import type { PostScreenNameParams, NickNameResponse, FetchNickNameParams } from './types';

// Post nickname
export const postNickName = ({
  url,
  JSESSIONID,
  screenName,
  tableId,
}: PostScreenNameParams): Promise<NickNameResponse> => {
  return Fetcher.fetch<NickNameResponse>(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      JSESSIONID,
    },
    body: { screenName, tableId },
  });
};

export const fetchNickName = ({ url, JSESSIONID }: FetchNickNameParams): Promise<NickNameResponse> => {
  return Fetcher.fetch<NickNameResponse>(url, {
    params: {
      JSESSIONID,
    },
    format: 'json',
    method: 'GET',
  });
};
